import { Link, useLocation } from 'react-router-dom';
import { Breadcrumb } from '../../lib/types';
import { useMemo } from 'react';

export const Breadcrumbs = () => {
  const location = useLocation();

  const breadCrumbs = useMemo<Breadcrumb[]>(() => {
    const breadCrumbArray: Breadcrumb[] = [
      { label: 'Image library', url: '/' },
    ];
    const { pathname, search } = location;
    if (pathname === '/search') {
      breadCrumbArray.push({
        label: 'Search results',
        url: `${pathname}?${search}`,
      });
    } else if (pathname === '/collection') {
      const queryParams: { label: string; value: string }[] = search
        .replace('?', '')
        .split('&')
        .map((params: string): { label: string; value: string } => {
          const [label, value] = params.split('=');
          return { label: label, value: value };
        });

      const collectionId: { label: string; value: string } | undefined =
        queryParams.find(
          (params: { label: string; value: string }): boolean => {
            return params.label === 'id';
          }
        );

      const collectionName: { label: string; value: string } | undefined =
        queryParams.find(
          (params: { label: string; value: string }): boolean => {
            return params.label === 'name';
          }
        );
      breadCrumbArray.push({
        label: decodeURI(collectionName?.value || 'Collection').replace(
          /\+/g,
          ' '
        ),
        url: `${pathname}?id=${collectionId?.value}&name=${collectionName?.value}`,
      });

      const resourceSet: { label: string; value: string } | undefined =
        queryParams.find(
          (params: { label: string; value: string }): boolean => {
            return params.label === 'resource';
          }
        );
      if (resourceSet) {
        breadCrumbArray.push({
          label: 'Image',
          url: `${pathname}?${search}}`,
        });
      }
    } else if (pathname === '/user/collections') {
      breadCrumbArray.push({
        label: 'Your collections',
        url: `${pathname}`,
      });
    }
    return breadCrumbArray;
  }, [location]);

  return (
    <div className="breadcrumbs-bar">
      <div className="block block-system block-system-breadcrumb-block">
        <nav className="breadcrumb">
          <ol>
            <li>
              <a href="/">Home&nbsp;</a>
            </li>
            {breadCrumbs.map((breadCrumb: Breadcrumb) => {
              return (
                <li key={`${breadCrumb.url}-${breadCrumb.label}`}>
                  <Link to={breadCrumb.url}>
                    &nbsp;{breadCrumb.label}&nbsp;
                  </Link>
                </li>
              );
            })}
          </ol>
        </nav>
      </div>
    </div>
  );
};
